import React, { useState, useCallback } from "react";
import ResolutionDurationBreakdownChartView from "./ResolutionDurationBreakdownChartView";
import ResolutionDurationBreakdownDrillDownModal from "./ResolutionDurationBreakdownDrillDownModal";
import { usePagesContent } from "../../../Hooks/usePagesContent";
import { CHART_TYPES } from "./chartConfig";

const ResolutionDurationBreakdownChart = ({ startDate, endDate, globalFilters = {} }) => {
  const pagesContent = usePagesContent();
  const [drillDownOpen, setDrillDownOpen]         = useState(false);
  const [selectedDataPoint, setSelectedDataPoint] = useState(null);

  const handleDataPointClick = useCallback((clickedData, currentGroupBy) => {
    setSelectedDataPoint({ ...clickedData, currentGroupBy });
    setDrillDownOpen(true);
  }, []);

  const chartMeta = pagesContent?.metaInfo?.charts?.[CHART_TYPES.RESOLUTION_DURATION_BREAKDOWN];

  if (!pagesContent?.mounted || chartMeta?.enabled === false) return null;

  const title = chartMeta?.title || "Battery System Alert Avg. Resolution Duration Breakdown";

  return (
    <>
      <ResolutionDurationBreakdownChartView
        title={title}
        height="582px"
        startDate={startDate}
        endDate={endDate}
        globalFilters={globalFilters}
        onDataPointClick={handleDataPointClick}
      />
      <ResolutionDurationBreakdownDrillDownModal
        open={drillDownOpen}
        onClose={() => setDrillDownOpen(false)}
        selectedDataPoint={selectedDataPoint}
        chartTitle={title}
        startDate={startDate}
        endDate={endDate}
        globalFilters={globalFilters}
      />
    </>
  );
};

export default ResolutionDurationBreakdownChart;
